(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    /* Compte à rebours jusqu'à minuit LOCAL du visiteur (fuseau du navigateur), repart à 23:59:59 chaque jour.
       Même calcul que la carte promo atc_banner (sections/main-product.liquid) et ticks réalignés sur la seconde
       d'horloge à chaque battement → la barre et la carte affichent la même valeur au même instant. */
    if (customElements.get('chronos-countdown')) return;

    function secondsToLocalMidnight() {
      var now = new Date();
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      var s = Math.max(0, Math.floor((midnight - now) / 1000));
      return s >= 86400 ? 86399 : s;
    }

    function pad(n) { return String(n).padStart(2, '0'); }

    class ChronosCountdown extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.units = {
          h: this.querySelector('[data-unit="h"]'),
          m: this.querySelector('[data-unit="m"]'),
          s: this.querySelector('[data-unit="s"]')
        };
        (function loop() {
          self.render();
          self._timeout = setTimeout(loop, 1005 - (Date.now() % 1000));
        })();
        this.setAttribute('ready', '');
      }

      disconnectedCallback() {
        clearTimeout(this._timeout);
      }

      render() {
        var d = secondsToLocalMidnight();
        if (this.units.h) this.units.h.textContent = pad(Math.floor(d / 3600));
        if (this.units.m) this.units.m.textContent = pad(Math.floor((d % 3600) / 60));
        if (this.units.s) this.units.s.textContent = pad(d % 60);
      }
    }

    customElements.define('chronos-countdown', ChronosCountdown);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Sous-nav : sur mobile chaque rangée défile horizontalement.
  // 1) l'entrée courante est centrée dans le scroll pour rester VISIBLE (ex. « All » en fin de rangée) ;
  // 2) fondu + flèche au bord tant qu'il reste des entrées hors écran (indice de swipe) ;
  // 3) une fois par session, la 1re rangée qui déborde glisse de 48 px puis revient.
  // No-op quand tout tient (desktop). Custom element : se ré-initialise seul quand
  // les filtres AJAX remplacent la section. Aucun défilement de page.
  if (!customElements.get('collection-subnav')) {
    customElements.define('collection-subnav', class extends HTMLElement {
      connectedCallback() {
        this.rows = Array.from(this.querySelectorAll('.collection-subnav__row'));
        this.rows.forEach((row) => {
          const list = row.querySelector('.collection-subnav__list');
          const more = row.querySelector('.collection-subnav__more:not(.collection-subnav__more--prev)');
          const prev = row.querySelector('.collection-subnav__more--prev');
          const active = list.querySelector('.collection-subnav__link.is-active');
          row.updateEdges = () => {
            const max = list.scrollWidth - list.clientWidth;
            row.classList.toggle('can-scroll-start', list.scrollLeft > 4);
            row.classList.toggle('can-scroll-end', max - list.scrollLeft > 4);
          };
          if (active && list.scrollWidth > list.clientWidth) {
            const offset = active.getBoundingClientRect().left - list.getBoundingClientRect().left;
            list.scrollLeft += offset - (list.clientWidth - active.offsetWidth) / 2;
          }
          list.addEventListener('scroll', row.updateEdges, { passive: true });
          if (more) more.addEventListener('click', () => list.scrollBy({ left: list.clientWidth * 0.7, behavior: 'smooth' }));
          if (prev) prev.addEventListener('click', () => list.scrollBy({ left: -list.clientWidth * 0.7, behavior: 'smooth' }));
          row.updateEdges();
        });
        this.resizeObserver = new ResizeObserver(() => this.rows.forEach((row) => row.updateEdges()));
        this.resizeObserver.observe(this);
        this.peek();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      peek() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        try { if (sessionStorage.getItem('c19-subnav-peek')) return; } catch (e) {}
        const row = this.rows.find((r) => r.classList.contains('can-scroll-end') && !r.classList.contains('can-scroll-start'));
        if (!row) return;
        try { sessionStorage.setItem('c19-subnav-peek', '1'); } catch (e) {}
        const list = row.querySelector('.collection-subnav__list');
        setTimeout(() => {
          list.scrollTo({ left: 48, behavior: 'smooth' });
          setTimeout(() => list.scrollTo({ left: 0, behavior: 'smooth' }), 600);
        }, 800);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    function pad(n) { return String(n).padStart(2, '0'); }

    function tick(el) {
      var now = new Date();
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      var diff = Math.max(0, Math.floor((midnight - now) / 1000));
      if (diff >= 86400) diff = 86399;
      el.textContent = pad(Math.floor(diff / 3600)) + ':' + pad(Math.floor((diff % 3600) / 60)) + ':' + pad(diff % 60);
    }

    // Ticks réalignés sur la seconde d'horloge à chaque battement (setTimeout, pas setInterval) : aucune dérive,
    // et même instant de bascule que la barre « Sale countdown » (sections/announcement-bar.liquid, même calcul).
    function startTimers(root) {
      (root || document).querySelectorAll('.wwbx-time').forEach(function (el) {
        if (el._wwbxTimer) clearTimeout(el._wwbxTimer);
        (function loop() {
          tick(el);
          el._wwbxTimer = setTimeout(loop, 1005 - (Date.now() % 1000));
        })();
      });
    }

    function stopTimers(root) {
      (root || document).querySelectorAll('.wwbx-time').forEach(function (el) {
        if (el._wwbxTimer) { clearTimeout(el._wwbxTimer); el._wwbxTimer = null; }
      });
    }

    function flashCopied(textEl, original) {
      if (!textEl) return;
      textEl.textContent = 'COPIED ✓';
      textEl.style.color = 'rgba(133, 204, 133, 0.95)';
      setTimeout(function () { textEl.textContent = original; textEl.style.color = ''; }, 1400);
    }

    function fallbackCopy(text, done) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      done();
    }

    // Copy via delegation: survives editor re-renders, never double-binds.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.wwbx-code-btn') : null;
      if (!btn) return;
      var textEl = btn.querySelector('.wwbx-code-text');
      var code = (btn.getAttribute('data-code') || '').trim();
      var original = textEl ? textEl.textContent : code;
      var done = function () { flashCopied(textEl, original); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function () { fallbackCopy(code, done); });
      } else {
        fallbackCopy(code, done);
      }
    });

    // Initial start + Shopify theme editor lifecycle (clean clearInterval, no stacking).
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { startTimers(document); });
    } else {
      startTimers(document);
    }
    document.addEventListener('shopify:section:load', function (e) { startTimers(e.target); });
    document.addEventListener('shopify:section:unload', function (e) { stopTimers(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
